import type { SubUnitInfo } from '../controllers/autocomplete.parser';

export const DEBUG_UNIT_EXTRACTION = false;

export const UnitLogger = {
  start: (address: string) => {
    DEBUG_UNIT_EXTRACTION && console.log('⭐ Extracting unit from address:', address);
  },
  normalized: (address: string) => {
    DEBUG_UNIT_EXTRACTION && console.log('📝 Normalized address:', address);
  },
  pattern: (prefix: string, pattern: string) => {
    DEBUG_UNIT_EXTRACTION && console.log(`🔍 Checking ${prefix} pattern:`, pattern);
  },
  match: (prefix: string, match: RegExpMatchArray) => {
    DEBUG_UNIT_EXTRACTION && console.log(`✅ Found match for ${prefix}:`, match);
  },
  result: (result: SubUnitInfo) => {
    DEBUG_UNIT_EXTRACTION && console.log('🎯 Extracted unit info:', result);
  },
  noMatch: () => {
    DEBUG_UNIT_EXTRACTION && console.log('❌ No unit information found in address');
  },
  source: (source: string, address: string) => {
    DEBUG_UNIT_EXTRACTION && console.log(`🏢 Extracting unit from ${source} address:`, address);
  },
  info: (source: string, info: SubUnitInfo) => {
    DEBUG_UNIT_EXTRACTION && console.log(`📦 ${source} unit info result:`, info);
  }
}; 